import {
  FEATURED_CHEFS,
  FEATURED_DISHES,
  GET_CHEF,
  LOADING_CHEF,
  SET_CURRENT_BOOKING,
  SET_CHEF_FILTERS,
  CLEAR_CHEF_FILTERS,
  SET_DISH_FILTERS,
  CLEAR_DISH_FILTERS,
  CHEF_TRANSACTIONS,
  TRANSACTION_FILTERS,
  SET_CHEF_SEARCH_BY_NAME,
  SET_DISH_SEARCH_BY_NAME,
} from "../stateConstants";
import { client } from "../../config/apollo";
import { GET_CHEF_DETAILS, GET_CHEF_TRANSACTIONS, GET_CHEF_ACCOUNTING } from "../../graphql/queries/chef";
import moment from 'moment';

const initialState = {
  featuredChefs: [],
  featuredDishes: [],
  chef: null,
  chefSearchName: 'a',
  dishSearchName: 'a',
  schedule: null,
  currentBooking: null,
  chefLoading: false,
  filters: {},
  dishFilters: {},
  transactions: [],
  transactionFilters: {
    endDate: moment().subtract(1, 'days').valueOf(),//.format('DD MMM YYYY'),
    startDate: moment().subtract(8, 'days').valueOf(),//.format('DD MMM YYYY'),
    sortOnField: 'date',
    sortDescending: true,
  },
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    default:
      return state;

    case FEATURED_CHEFS:
      return {
        ...state,
        featuredChefs: action.result
      };

    case FEATURED_DISHES:
      return {
        ...state,
        featuredDishes: action.result
      };

    case SET_CURRENT_BOOKING:
      return {
        ...state,
        currentBooking: action.result
      };

    case GET_CHEF:
      return {
        ...state,
        chef: action.result,
        loadingChef: false
      };
    case LOADING_CHEF:
      return {
        ...state,
        loadingChef: true
      };
    case SET_CHEF_FILTERS:
      return {
        ...state,
        filters: action.result
      };
    case CLEAR_CHEF_FILTERS:
      return {
        ...state,
        filters: {}
      };
    case SET_DISH_FILTERS:
      return {
        ...state,
        dishFilters: action.result
      };
    case CLEAR_DISH_FILTERS:
      return {
        ...state,
        dishFilters: {}
      };

    case TRANSACTION_FILTERS:
      return {
        ...state,
        transactionFilters: action.result,
      };

    case CHEF_TRANSACTIONS:
      return {
        ...state,
        transactions: action.result,
      };

    case SET_CHEF_SEARCH_BY_NAME:
      return {
        ...state,
        chefSearchName: action.payload,
      };

    case SET_DISH_SEARCH_BY_NAME:
      return {
        ...state,
        dishSearchName: action.payload,
      };
  }
};

export default reducer;

export const setFeaturedChefs = list => {
  return dispatch => {
    dispatch({
      action: FEATURED_CHEFS,
      result: list
    });
  };
};

export const setFeaturedDishes = list => {
  return dispatch => {
    dispatch({
      action: FEATURED_DISHES,
      result: list
    });
  };
};

export const setCurrentBooking = booking => {
  localStorage.setItem("booking", JSON.stringify(booking));
  return dispatch => {
    dispatch({
      type: SET_CURRENT_BOOKING,
      result: booking
    });
  };
};

export const getCurrentBooking = () => {
  return dispatch => {
    dispatch({
      type: SET_CURRENT_BOOKING,
      result: JSON.parse(localStorage.getItem("booking"))
    });
  };
};

export const setChefFilters = filters => {
  localStorage.setItem("chefFilters", JSON.stringify(filters));
  return dispatch => {
    dispatch({
      type: SET_CHEF_FILTERS,
      result: filters
    });
  };
};

export const getChefFilters = () => {
  return dispatch => {
    dispatch({
      type: SET_CHEF_FILTERS,
      result: JSON.parse(localStorage.getItem("chefFilters"))
    });
  };
};
export const clearChefFilters = () => {
  localStorage.removeItem("chefFilters");
  return dispatch => {
    dispatch({
      type: CLEAR_CHEF_FILTERS
    });
  };
};

export const setDishFilters = filters => {
  localStorage.setItem("dishFilters", JSON.stringify(filters));
  return dispatch => {
    dispatch({
      type: SET_DISH_FILTERS,
      result: filters
    });
  };
};

export const getDishFilters = () => {
  return dispatch => {
    dispatch({
      type: SET_DISH_FILTERS,
      result: JSON.parse(localStorage.getItem("dishFilters"))
    });
  };
};
export const clearDishFilters = () => {
  localStorage.removeItem("dishFilters");
  return dispatch => {
    dispatch({
      type: CLEAR_DISH_FILTERS
    });
  };
};

export const getChefDetails = chefId => {
  return dispatch => {
    dispatch({
      type: LOADING_CHEF
    });
    client
      .query({
        query: GET_CHEF_DETAILS,
        variables: {
          id: chefId
        },
        fetchPolicy: "network-only"
      })
      .then(response => {
        if (response.data) {
          const { chef } = response.data;

          if (chef.profilePic instanceof Array) {
            chef.profilePic = null;
          }

          dispatch({
            type: GET_CHEF,
            result: chef
          });
        }
      }).catch(err=>{
      dispatch({
        type: GET_CHEF,
        result: null
      });
    });
  };
};

export const setTransactionFilters = filters => {
  return (dispatch, getState) => {
    const { transactionFilters } = getState().chefs;
    dispatch({
      type: TRANSACTION_FILTERS,
      result: {...transactionFilters, ...filters},
    });
    dispatch(fetchTransactions());
  };
};

export const fetchTransactions = () => {
  return (dispatch, getState) => {
    const {transactionFilters} = getState().chefs;

    client.query({
      query: GET_CHEF_TRANSACTIONS,
      variables: {
        filters: transactionFilters,
        cursor: "",
        pageSize: 1000,
        next: null,
        previous: null,
      },
      fetchPolicy: 'network-only',
    })
      .then(response => {
        const { data } = response;

        if (!!data && !!data.listChefTransactions) {
          const { listChefTransactions: { transactions } } = data;
          dispatch({
            type: CHEF_TRANSACTIONS,
            result: transactions,
          });
        }

      })
      .catch(err => {
        console.log('TRANSACTION ERR: ', err);
      });
  };
};

export const fetchAccounting = (chefId) => {
  return (dispatch, getState) => {

    client.query({
      query: GET_CHEF_ACCOUNTING,
      variables: {
        chefId
      },
      fetchPolicy: 'network-only',
    })
      .then(response => {
        const { data } = response;

        if (!!data && !!data.fetchAccountingList) {
          const { fetchAccountingList } = data;
          dispatch({
            type: CHEF_TRANSACTIONS,
            result: fetchAccountingList,
          });
        }

      })
      .catch(err => {
        console.log('FETCH ACCOUNTING ERR: ', err);
      });
  };
};

export const setChefSearchByName = name => {
  return dispatch => dispatch({
    type: SET_CHEF_SEARCH_BY_NAME,
    payload: name,
  });
};

export const setDishSearchByName = name => {
  return dispatch => dispatch({
    type: SET_DISH_SEARCH_BY_NAME,
    payload: name,
  });
};
